module.exports = __webpack_public_path__ + "static/gallery-img-29-f739a55e5fc3341d66c09db77121becb.jpg";